<app-banner-app [retroSelected]=false></app-banner-app>

<br>
<div style="background-color: #DFEAFF;">
    <br><br>
    <div class="container">
        <div class="row">

            <div class="col">
                <div class="aliniacionImagen">
                    <img src="./assets/img/Pago_aprobado_1080x1080.png" [width]="320" 
                    alt="cotizar seguro de arrendamiento"/>
                </div>

                <div class="estilo_mensaje">
                    <h1 class="texto_Cotizacion">Coticemos tu<br />
                    Seguro de arriendo digital</h1>
                </div>
                <br>

                <div style="display: flex; justify-content: center; align-items:center;padding-bottom: 10px;">
                    <button class="btn btn-primary botonContinuar" (click)="conInquilino()">
                        <strong>Ya tengo inquilino</strong>
                    </button>
                </div>
                <div style="display: flex; justify-content: center; align-items:center;">
                    <button class="botonContinuarTransparente" (click)="sinInquilino()">
                       <strong>No tengo inquilino aún</strong>
                    </button>
                </div>


            </div>
        </div>
    </div>

    <br><br><br><br>
    <app-footer-app />

</div>